import { render, staticRenderFns } from "./AboutMeLibrary.vue?vue&type=template&id=52ea725a&scoped=true"
import script from "./AboutMeLibrary.vue?vue&type=script&lang=js"
export * from "./AboutMeLibrary.vue?vue&type=script&lang=js"
import style0 from "./AboutMeLibrary.vue?vue&type=style&index=0&id=52ea725a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ea725a",
  null
  
)

export default component.exports